import * as Yup from "yup";
export var FieldType;
(function (FieldType) {
    FieldType[FieldType["Select"] = 0] = "Select";
    FieldType[FieldType["Multiselect"] = 1] = "Multiselect";
    FieldType[FieldType["Text"] = 2] = "Text";
    FieldType[FieldType["Number"] = 3] = "Number";
    FieldType[FieldType["Currency"] = 4] = "Currency";
    FieldType[FieldType["Percent"] = 5] = "Percent";
    FieldType[FieldType["Date"] = 6] = "Date";
    FieldType[FieldType["Checkbox"] = 7] = "Checkbox";
    FieldType[FieldType["Hidden"] = 8] = "Hidden";
})(FieldType || (FieldType = {}));
export const standardValidation = {
    [FieldType.Checkbox]: Yup.boolean().nullable(),
    [FieldType.Select]: Yup.string().nullable(),
    [FieldType.Multiselect]: Yup.array().nullable(),
    [FieldType.Text]: Yup.string().nullable(),
    [FieldType.Number]: Yup.number()
        .transform(value => (isNaN(value) ? undefined : value))
        .nullable(),
    [FieldType.Currency]: Yup.number().nullable(),
    [FieldType.Percent]: Yup.number().nullable(),
    [FieldType.Date]: Yup.date().nullable(),
    [FieldType.Hidden]: Yup.mixed().nullable()
};
export const requiredValidation = {
    [FieldType.Checkbox]: Yup.boolean().required(),
    [FieldType.Select]: Yup.string().required(),
    [FieldType.Multiselect]: Yup.array().required().min(1),
    [FieldType.Text]: Yup.string().required(),
    [FieldType.Number]: Yup.number().required(),
    [FieldType.Currency]: Yup.number().required(),
    [FieldType.Percent]: Yup.number().required(),
    [FieldType.Date]: Yup.date().required(),
    [FieldType.Hidden]: Yup.mixed().nullable()
};
// Default FormTableSchema class with logic applicable for *all* kinds of FormTable schemas:
export class DefaultFormTableSchema {
    constructor(data) {
        const { tableData, columnData } = data;
        const ctor = this.constructor;
        this.columnMetadata = {
            addedManually: {
                fieldType: FieldType.Hidden,
                defaultValue: true
            },
            frontendOnlyId: {
                fieldType: FieldType.Hidden,
                defaultValueFunc: () => crypto.randomUUID()
            },
            ...columnData
        };
        this.tableMetadata = {
            dployTesterContext: ctor.name.replace("Schema", ""),
            ...tableData
        };
    }
}
//# sourceMappingURL=types.js.map